import Types from "./types";
import AssessmentServiceApi from "../../services/assessment-api";

const createHMAC = (data) => {
  return function (dispatch) {
    return AssessmentServiceApi.createHmac(data)
      .then((response) => {
        if (response) {
          return response;
        }
      })
      .catch((error) => console.log("Error"));
  };
};

export { createHMAC };
